import React from 'react';
import './FooterSection.css';
import logoWhite from '../assets/sweet-justice-logo-white.svg';

export default function FooterSection() {
  return (
    <footer className="footer-section section" id="contact">
      <div className="container footer-container">
        <div className="footer-logo" aria-hidden="true">
          <img src={logoWhite} alt="" />
        </div>
        <nav className="footer-links" aria-label="Sweet Justice">
          <a
            href="#request"
            onClick={(e) => {
              if (typeof window !== 'undefined' && typeof window.onRequestClick === 'function') {
                e.preventDefault();
                window.onRequestClick();
              }
            }}
          >
            Request Sweet Justice
          </a>
          <a
            href="#waiver"
            onClick={(e) => {
              e.preventDefault();
              try { window.dispatchEvent(new Event('sj-open-waiver')); } catch (_e) {}
            }}
          >
            Sign Waiver
          </a>
        </nav>
      </div>
    </footer>
  );
}
